<script setup lang="ts">
/**
 * 任务中心页内状态页签（收到的 / 发起的）
 */
import { computed } from 'vue'
import { useI18n } from 'vue-i18n'

const props = defineProps<{
  mode: 'received' | 'assigned'
  modelValue: string
  counts?: Record<string, number>
}>()

const emit = defineEmits<{
  'update:modelValue': [value: string]
}>()

const { t } = useI18n()

const tabs = computed(() => {
  if (props.mode === 'received') {
    return [
      { key: 'pending_accept', label: t('task.tabPendingAccept') },
      { key: 'in_review', label: t('task.tabInReview') },
      { key: 'submitted', label: t('task.tabSubmitted') },
      { key: 'ended', label: t('task.tabEnded') },
    ]
  }
  return [
    { key: 'waiting_other', label: t('task.tabWaitingOther') },
    { key: 'my_review', label: t('task.tabMyReview') },
    { key: 'ended', label: t('task.tabEnded') },
  ]
})

function onChange(key: string | number) {
  emit('update:modelValue', String(key))
}
</script>

<template>
  <a-tabs
    :active-key="modelValue"
    class="task-inbox-tabs"
    @change="onChange"
  >
    <a-tab-pane v-for="tab in tabs" :key="tab.key">
      <template #tab>
        <span>
          {{ tab.label }}
          <a-badge
            v-if="(counts?.[tab.key] ?? 0) > 0"
            :count="counts?.[tab.key]"
            :number-style="{ backgroundColor: '#1890ff' }"
            :offset="[6, -2]"
          />
        </span>
      </template>
    </a-tab-pane>
  </a-tabs>
</template>

<style scoped>
.task-inbox-tabs {
  margin-bottom: 8px;
}
</style>
